/*
Helper method to set up for using Font Awesome icons
*/

import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default function setup () {
  library.add(faBars, faTimes)

  Vue.component('font-awesome-icon', FontAwesomeIcon)
}



// WEBPACK FOOTER //
// ./src/helpers/font-awesome.js